import React from 'react';
import { Link } from 'react-router-dom';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-green-950 flex items-center justify-center px-6">
          <div className="text-center max-w-md">
            <div className="w-16 h-16 border border-red-800/40 flex items-center justify-center mx-auto mb-8">
              <span className="text-red-400 text-2xl">⚠</span>
            </div>
            <p className="text-gold-500 text-[10px] tracking-[0.4em] uppercase font-body mb-4">Something went wrong</p>
            <h1 className="font-display text-4xl text-cream font-light mb-6">Page Error</h1>
            <p className="text-cream/40 font-body text-sm mb-10">
              An unexpected error occurred. Please try refreshing the page.
            </p>
            <div className="flex gap-4 justify-center">
              <button
                onClick={() => { this.setState({ hasError: false }); window.location.reload(); }}
                className="btn-gold"
              >
                Reload Page
              </button>
              <Link to="/" className="btn-outline">Go Home</Link>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
